import React from 'react';
import { Link } from 'react-router-dom';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export class PracticeButton extends React.Component{
    render(){
        return(
            <Link to="/practice" style={{textDecoration : 'none'}} onClick={this.props.onClick}>
            <button className="App-button">
                Ich möchte Bubblesort üben!
            </button>
          </Link>
        )};
}

